export default __webpack_public_path__ + "static/media/planet5.45da23d1.png";